const parseFormData = (e) => {
    const formData = new FormData(e.target)
    const formDataObj = Object.fromEntries(formData.entries())

    return formDataObj
}

module.exports = {
    parseFormData
}